module.exports = __webpack_public_path__ + "img/star2.93a0bed3.png";